import {
  PhoneIcon,
  PrinterIcon,
  AtSymbolIcon,
  EnvelopeIcon,
} from "@heroicons/react/20/solid";

export default function Footer() {
  return (
    <footer className="absolute bottom-0 z-50 h-36 w-full border-t border-t-black bg-gray-200 py-3">
      <div className="mx-auto flex w-full max-w-[85rem] justify-around p-4">
        <div className="basis-2/5">
          <h3 className="font-serif text-2xl font-bold italic">
            &copy;&nbsp;EVTCC&nbsp;2024
          </h3>
          <p className="pl-6 font-serif italic">evtcc.org</p>
        </div>
        <div className="shrink-0 basis-3/5">
          <div className="flex flex-wrap items-center justify-around gap-x-10 gap-y-4 lg:items-start">
            <div className="flex flex-col space-y-3">
              <div className="flex items-center space-x-2">
                <PhoneIcon className="size-5 md:size-6" />
                <span>(847) 426-4075</span>
              </div>
              <div className="flex items-center space-x-2">
                <AtSymbolIcon className="size-5 md:size-6" />
                <span>evtcert@evtcc.org </span>
              </div>
              <div className="flex items-center space-x-2">
                <PrinterIcon className="size-5 md:size-6" />
                <span>(847) 426-4076</span>
              </div>
            </div>

            <div className="hidden space-x-2 xl:flex">
              <EnvelopeIcon className="size-5 md:size-6" />
              <div>
                <div className="font-bold">EVTCC</div>
                <div>P.O. Box 894</div>
                <div>Dundee, IL 60118</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
